export default {
  title: '30-Day Money-Back',
  subtitle: 'Guarantee Without Questions',
  text: 'We believe that the Dr. Kegel plan will work for you, and you’ll get tangible improvements within the first month! And we are so confident that we are even ready to {bold_1}. All you have to do is send an email to {email} {bold_2}. But we are sure that the plan will show its effectiveness and there will be no need for a refund. Find more about the refund process in our {link}.',
  bold_1: 'return your money without any questions',
  bold_2: 'within 30 days and ask for a refund',
  link: 'refund policy'
}
